import { render } from "./MascotWidget.vue?vue&type=template&id=5e4c76a5&scoped=true"
import script from "./MascotWidget.vue?vue&type=script&lang=js"
export * from "./MascotWidget.vue?vue&type=script&lang=js"

import "./MascotWidget.vue?vue&type=style&index=0&id=5e4c76a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4c76a5"]])

export default __exports__